import {
  // 登录页
  LOGIN_IN,
  // DISABLE_LOGIN,
  // ABLE_LOGIN,
  // 注册页
  DISABLE_SIGNUP,
  ABLE_SIGNUP,
  GET_IMAGE_CODE,
  GET_COUNTRY_INFO,
  // 首页
  INVITECODE_STATUS_CODE,
  GET_MAINLAND_LIST,
  GET_NON_MAINLAND_LIST,
  GET_CALCULATE_LIST,
  GET_USER_INFO,
  GET_ALL_RENVUE,
  // GET_LASTDAY_INVITE,
  // ACCOUNT_REVENUE_LIST,
  GET_RENVUE_DETAIL,
  // 推荐
  GET_RECOMMEND_INFO,
  GET_RECOMMEND_COUNT,
  // 硬件列表
  GET_HARDLIST,
  GET_SEARCH_LIST,
  // ACCOUNT_LASTDAY_REVENUE,
  // eth地址绑定
  GET_WALLET_ADDRESS,
  GET_WALLET_STATUS,
  // 提现
  GET_WITHDRAWAL_LIST,
  GET_BALANCE,
  GET_WITHDRAWAL_STAUTS,
  GET_INVITE_DETAIL,
  GET_NETWORK_CONTRIBUTION,
  GET_DEVICE_OVERVIEW,
  SET_FILTER_TYPE,
  SET_LAST_SEVEN_PRICE,
  BUYBACK_LIST,
  BUYBACK_AUTH,
  // 微信
  GET_WECHAT_INFO,
  GET_WECHAT_BANLANCE,
  GET_WECHAT_SEVENDAYPRICE,
  GET_DIAL_CONFIG,
  GET_Node_CONFIG,
  // 兑换
  GET_EXCHANGE_INFO,
  GET_EXCHANGE_LIST,
  GET_DIAL_STATUS,



  
  GET_BUSINESS
} from './mutation-types.js'

// import {setStore, getStore} from '../config/mUtils'
// import {localapi, proapi} from 'src/config/env'
import { getCookie } from "@/utils/utils";

export default {
  // login 
  [LOGIN_IN](state, status) {
    state.account.loginStatus = status;
    state.account = Object.assign({}, state.account);
  },
  //  signup不可点击
  [DISABLE_SIGNUP](state) {
    console.log(123);
    state.signUp.isSignUpDisable = true;
    state.signUp = Object.assign({}, state.signUp);
  },
  //  signup可点击
  [ABLE_SIGNUP](state) {
    console.log(123);
    state.signUp.isSignUpDisable = false;
    state.signUp = Object.assign({}, state.signUp);
  },
  // 图片验证码地址
  [GET_IMAGE_CODE](state, imageUrl) {
    console.log(123456);
    console.log(imageUrl);
    // const signUp = (Object.assign({}, this.state.signUp, { imageCodeSrc: imageUrl, });
    state.signUp.imageCodeSrc = imageUrl;
    state.signUp = Object.assign({}, state.signUp);
  },
  // 图片邀请码状态
  [INVITECODE_STATUS_CODE](state, status) {
    // const signUp = (Object.assign({}, this.state.signUp, { imageCodeSrc: imageUrl, });
    state.inviteCode.status = status;
    state.inviteCode = Object.assign({}, state.inviteCode);
  },
  // 大陆码	
  [GET_MAINLAND_LIST](state, list) {
    state.inviteCode.mainland_list = list;
    state.inviteCode = Object.assign({}, state.inviteCode);
  },
  // 大陆码
  [GET_NON_MAINLAND_LIST](state, list) {
    state.inviteCode.non_mainland_list = list;
    state.inviteCode = Object.assign({}, state.inviteCode);
  },
  // 计算码	
  [GET_CALCULATE_LIST](state, list) {	
    state.inviteCode.calculate_list = list;	
    state.inviteCode = Object.assign({}, state.inviteCode);	
  },
  // 获取用户信息
  [GET_USER_INFO](state, emaill) {
    state.account.email = emaill;
    state.account = Object.assign({}, state.account);
  },
  [GET_COUNTRY_INFO](state, country) {
    state.country = country;
    state.country = Object.assign({}, state.country);
  },
  // 用户收益
  [GET_ALL_RENVUE](state, ret) {
    // let {balance= 0, totalInvite = 0, totalNetRevenue= 0, totalOnlineRevenue= 0, totalRevenue= 0} = ret;
    state.revenue = ret;
    state.revenue = Object.assign({}, state.revenue);
  },
  //  用户邀请收益
  // [GET_LASTDAY_INVITE](state, revenueList) {
  //   state.revenue.inviteRevenue = revenueList;
  //   state.revenue = Object.assign({}, state.revenue);
  // },
  // //  用户个人收益详情
  // [ACCOUNT_LASTDAY_REVENUE](state, revenueList) {
  //   state.revenue.accountRevenue = revenueList;
  //   state.revenue = Object.assign({}, state.revenue);
  // },
  //  用户推荐链接
  [GET_RECOMMEND_INFO](state, recommend) {
    state.recommend.recommendRefer = recommend;
    state.recommend = Object.assign({}, state.recommend);
  },
  //  用户推荐总人数
  [GET_RECOMMEND_COUNT](state, count) {
    state.recommend.count = count;
    state.recommend = Object.assign({}, state.recommend);
  },
  //  收益详情
  [GET_RENVUE_DETAIL](state, deviceDetail) {
    state.revenueDetail.currentPage = Number(deviceDetail.currentPage);
    state.revenueDetail.deviceLength = deviceDetail.deviceLength;
    state.revenueDetail.deviceNumSize = deviceDetail.pageSize || 0;
    state.revenueDetail.detailList = deviceDetail.detailList || 'NO_CONTENT';
    state.revenueDetail.allDevices = deviceDetail.allDevices || [];

    deviceDetail.totalBxc && (state.revenueDetail.bxc = deviceDetail.totalBxc.bxc);
    deviceDetail.totalBxc && (state.revenueDetail.compute_bxc = deviceDetail.totalBxc.compute_bxc);
    deviceDetail.totalBxc && (state.revenueDetail.network_bxc = deviceDetail.totalBxc.network_bxc);
    state.revenueDetail = Object.assign({}, state.revenueDetail);
  },
  //  用户邀请收益详情
  [GET_INVITE_DETAIL](state, inviteDetail) {
    state.inviteDetail.currentPage = Number(inviteDetail.currentPage);
    state.inviteDetail.length = inviteDetail.length;
    state.inviteDetail.numSize = inviteDetail.numSize;
    state.inviteDetail.detailList = inviteDetail.detailList || 'NONE';
    state.inviteDetail = Object.assign({}, state.inviteDetail);
  },
  //  获取硬件列表
  [GET_HARDLIST](state, hardList) {
    state.hardWare.list = hardList.list || 'NO_CONTENT';
    state.hardWare.hardLength = hardList.deviceLength || 0;
    state.hardWare.deviceSize = Number(hardList.pageSize) || 0;
    state.hardWare.currentPage = Number(hardList.currentPage) || 0;
    // // 方便搜索
    state.hardWare.allDevices = hardList.allDevices || [];
    state.hardWare = Object.assign({}, state.hardWare);
  },
  //  获取硬件列表
  [GET_SEARCH_LIST](state, hardList) {
    state.hardWare.list = hardList || 'NO_CONTENT';
    state.hardWare.hardLength = 1;
    state.hardWare.deviceSize = 1;
    state.hardWare.currentPage = 1;
    state.hardWare = Object.assign({}, state.hardWare);
  },
  //  ETH地址绑定
  [GET_WALLET_ADDRESS](state, address) {
    state.wallet.address = address;
    state.wallet = Object.assign({}, state.wallet);
  },
  //  ETH状态获取
  [GET_WALLET_STATUS](state, eth_verify_status) {
    state.wallet.eth_verify_status = eth_verify_status;
    state.wallet = Object.assign({}, state.wallet);
  },
  //  提现
  [GET_WITHDRAWAL_LIST](state, list) {
    state.withdrawal.list = list;
    state.withdrawal = Object.assign({}, state.withdrawal);
  },
  [GET_BALANCE](state, balance) {
    state.withdrawal.balance = balance;
    state.withdrawal = Object.assign({}, state.withdrawal);
  },
  [GET_WITHDRAWAL_STAUTS](state, withStatus) {
    state.withdrawal.commitStatus = withStatus;
    state.withdrawal = Object.assign({}, state.withdrawal);
  },
  [GET_NETWORK_CONTRIBUTION](state, networkContribution) {
    state.networkContribution = networkContribution || 'NODATA';
    // state.networkContribution = Object.assign({}, state.networkContribution);
  },
  [GET_DEVICE_OVERVIEW](state, overview) {
    state.device.overview = overview || 'NODATA';
    state.device = Object.assign({}, state.device);
  },
  [SET_FILTER_TYPE](state, filterType) { 
    state.device.filterType = filterType;
    state.hardWare.currentPage = 1;
    state.device = Object.assign({}, state.device);
    state.hardWare = Object.assign({}, state.hardWare);
  },
  // 过去7天均价
  [SET_LAST_SEVEN_PRICE](state, data) { 
    // state.buyBack.lastSevenPrice = data.price;
    state.buyBack.RMBPrice = data.RMBPrice;
    state.buyBack.discount = data.discount;
    state.buyBack.minAmount = data.minAmount;
    state.buyBack.maxAmount = data.maxAmount;
    state.buyBack.BUYBACK_COUNT = data.BUYBACK_COUNT;
    state.buyBack.BUYBACK_MONEY_COUNT = data.BUYBACK_MONEY_COUNT;
    state.buyBack.TYPE_3_SHUI = data.TYPE_3_SHUI;
    state.buyBack.TYPE_2_SHUI = data.TYPE_2_SHUI;
    state.buyBack.TYPE_1_SHUI = data.TYPE_1_SHUI;
    state.buyBack = Object.assign({}, state.buyBack);
  },
  // 回购列表
  [BUYBACK_LIST](state, buyBackList) { 
    state.buyBack.buyBackList = buyBackList;
    state.buyBack = Object.assign({}, state.buyBack);
  },
  // 回购权限
  [BUYBACK_AUTH](state, data) { 
    state.buyBack.auth = data;
    state.buyBack = Object.assign({}, state.buyBack);
  },
  // 微信
  [GET_WECHAT_INFO](state, data) { 
    state.wechat.openid = data.openid;
    state.wechat.emails = data.emails || [];
    state.wechat.revenues = data.revenues || [];
    state.wechat.deviceInfos = data.deviceInfos || [];

    state.buyBack = Object.assign({}, state.buyBack);
  },
  // 拨号
  [GET_DIAL_CONFIG](state, data) { 
    state.standardNode.dialConfig = data || [];
    state.standardNode = Object.assign({}, state.standardNode);
  },
  [GET_Node_CONFIG](state, data) { 
    state.standardNode.nodeConfig = data || [];
    state.standardNode = Object.assign({}, state.standardNode);
  },

  [GET_EXCHANGE_INFO](state, data) {
    state.exchange.RMBPrice = data.RMBPrice || '';
    state.exchange.balance = data.balance || '';
    state.exchange.canExchangeCount = data.canExchangeCount || {};
    state.exchange.canExchangeMoney = data.canExchangeMoney || [];
    state.exchange = Object.assign({}, state.exchange);
  },
  [GET_EXCHANGE_LIST](state, data) { 
    state.exchange.exchangeList = data || [];
    state.exchange = Object.assign({}, state.exchange);
  },
  [GET_DIAL_STATUS](state, data) { 
    state.dialStatus.total = data.total;
    state.dialStatus.normal = data.normal;
    state.dialStatus.error = data.error;
    state.dialStatus.serverList = data.serverList && data.serverList.length ? data.serverList : 'NODATA';
    state.dialStatus = Object.assign({}, state.dialStatus);
  },
  
//微信公众号提现功能
  [GET_WECHAT_BANLANCE](state, balance) {
    state.wechat.balance = balance;
    state.wechat = Object.assign({}, state.wechat);
  },
  [GET_WECHAT_SEVENDAYPRICE](state, res) {
    state.wechat.RMBPrice = res.RMBPrice;
    state.wechat.BUYBACK_COUNT = res.BUYBACK_COUNT;
    state.wechat.BUYBACK_MONEY_COUNT = res.BUYBACK_MONEY_COUNT;
    state.wechat.TYPE_1_SHUI = res.TYPE_1_SHUI;
    state.wechat.TYPE_2_SHUI = res.TYPE_2_SHUI;
    state.wechat.TYPE_3_SHUI = res.TYPE_3_SHUI;
    state.wechat.discount = res.discount;
    state.wechat.maxAmount = res.maxAmount;
    state.wechat.minAmount = res.minAmount;
    state.wechat = Object.assign({}, state.wechat);
  },
  //清空数据
  claerBalance(state){
    state.exchange.balance = '';
    state.exchange.RMBPrice = '';
    state.exchange.canExchangeCount = '';
    state.exchange.canExchangeMoney = '';
  },




    // 获取业务方
    [GET_BUSINESS](state, data) {
      state.bill.business = data;
    }
}
